import TriggerTemplateParams from './TriggerTemplateParams';

export default TriggerTemplateParams;
